import React, { useState, useEffect } from 'react'
import { Tabs } from 'antd'

import Product from './Product'
import Variant from './Variant'
import CategorySection from './CategorySection'
import Category from './Category'
import { getApi } from '../../helpers'
import SubCategory from './SubCategory'

export default function Products() {
  const [stores, setStores] = useState([])
  const [activeKey, setActiveKey] = useState('1')

  useEffect(() => getStores(), [])

  const getStores = async () => {
    const res = await getApi({}, "getStores", "dashboard/");
    if (res.data && res.data.length) setStores(res.data);
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  return (
    <div className="card-container">
      <Tabs
        type="card"
        activeKey={activeKey}
        onChange={handleTabChange}
        destroyInactiveTabPane={true}
      >
        <Tabs.TabPane tab='Product' key='1'>
          <Product stores={stores} />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Variant' key='2'>
          <Variant stores={stores} />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Category Section' key='3'>
          <CategorySection />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Category' key='4'>
          <Category />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Sub Category' key='5'>
          <SubCategory />
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
}
